export default {"src":"/_next/static/media/upgrade-offer-background.8b9fd36c.svg","height":279,"width":726,"blurWidth":0,"blurHeight":0};